/**
 * @author Mark Cremer <mark@firstcoders.co.uk>
 */
angular.module('pitch.app')

.factory('SynchEnquiry', function(config, $resource) {
    return $resource(config.apiUri + '/sites/:site/synch-enquiry', {
        site: '@site'
    });
})

;




// WEBPACK FOOTER //
// ./src/AppBundle/Resources/js/angular/services/Synch.js